module.exports = __webpack_public_path__ + "static/008129-1a505308f4b12bfa5adde47a6c6f6435.jpg";